import { render, staticRenderFns } from "./BlockAccount.vue?vue&type=template&id=002f74c6&scoped=true&"
import script from "./BlockAccount.vue?vue&type=script&lang=js&"
export * from "./BlockAccount.vue?vue&type=script&lang=js&"
import style0 from "./BlockAccount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BlockAccount.vue?vue&type=style&index=1&id=002f74c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f74c6",
  null
  
)

export default component.exports